import InvoiceComponent from '@/components/Pages/Invoice.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/company/:companyId/folder/:folderId/invoice',
  props: true,
  name: RouteNames.Invoice,
  component: InvoiceComponent,
};

export default route;
